import { Button, Modal, TextInput } from '@octano/global-ui';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'reactstrap';

import { EnrollmentTransferSummary } from '../../../types/studentStatusTypes';

interface ModalTransferDetailsProps {
  open: boolean;
  onClose: () => void;
  transfer: EnrollmentTransferSummary;
}

const ModalTransferDetails = ({
  open,
  onClose,
  transfer,
}: ModalTransferDetailsProps) => {
  const prefix = 'studentStatus.transferTooltip';
  const { t } = useTranslation();
  const empty = t(`${prefix}.emptyValue`);

  return (
    <Modal isOpen={open} toggle={onClose}>
      <Row className="pb-4">
        <Col xs={12} className="text-center">
          <h1 className="text-dark fs-22">{t(`${prefix}.modal.title`)}</h1>
        </Col>
      </Row>
      <Row className="pb-2 pt-4">
        <Col xs={12}>
          <TextInput
            label={t(`${prefix}.field.type`)}
            name="type"
            value={t(`${prefix}.type.${transfer.type}`)}
            disabled
          />
        </Col>
        <Col xs={12}>
          <TextInput
            label={t(`${prefix}.field.sourcePlan`)}
            name="sourcePlan"
            value={transfer.sourceProgramName || empty}
            disabled
          />
        </Col>
        <Col xs={12}>
          <TextInput
            label={t(`${prefix}.field.sourcePeriod`)}
            name="sourcePeriod"
            value={transfer.sourceAdmissionPeriod || empty}
            disabled
          />
        </Col>
        <Col xs={12}>
          <TextInput
            label={t(`${prefix}.field.currentPlan`)}
            name="currentPlan"
            value={transfer.currentStudyPlanName || empty}
            disabled
          />
        </Col>
        <Col xs={12}>
          <TextInput
            label={t(`${prefix}.field.transferPeriod`)}
            name="transferPeriod"
            value={transfer.currentTransferPeriod || empty}
            disabled
          />
        </Col>
      </Row>
      <Row className="pb-2 pt-4">
        <Col className="mx-auto" xs={12} sm={12}>
          <Button
            onClick={onClose}
            text={t(`${prefix}.modal.close`)}
            outlined
            fullwidth
          />
        </Col>
      </Row>
    </Modal>
  );
};

export default ModalTransferDetails;
